import { render, staticRenderFns } from "./ServeCopyOfOrderOnOtherParty.vue?vue&type=template&id=727b09ec"
import script from "./ServeCopyOfOrderOnOtherParty.vue?vue&type=script&lang=ts"
export * from "./ServeCopyOfOrderOnOtherParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports